/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ApplicationView, SystemRoleBit } from '@gh/builder-shared-data';
import { ApplicationState, ApplicationStatePredicate, whenOneOf } from '@gh/common-shared';
import { constant } from 'lodash';
import { BuilderApplicationState } from './builder-application-state';

export function getBuilderState(snapshot: ApplicationState): BuilderApplicationState {
  return <BuilderApplicationState>snapshot;
}

export function whenApplicationViewEq(view: ApplicationView): ApplicationStatePredicate {
  return (snapshot) => getBuilderState(snapshot).applicationView === view;
}

export function whenOfficeUser(): ApplicationStatePredicate {
  return (snapshot) =>
    whenApplicationViewEq(ApplicationView.Office)(snapshot)
    && !getBuilderState(snapshot).isSwitched();
}

export function whenSwitchedUser(): ApplicationStatePredicate {
  return (snapshot) =>
    whenApplicationViewEq(ApplicationView.Office)(snapshot)
    && getBuilderState(snapshot).isSwitched();
}

export const whenCorporateView = constant(whenApplicationViewEq(ApplicationView.Corporate));
export const whenMasterZoneView = constant(whenApplicationViewEq(ApplicationView.Master));
export const whenOfficeView = constant(whenApplicationViewEq(ApplicationView.Office));
export const whenCorporateOrMasterZoneView = constant(whenOneOf(whenCorporateView(), whenMasterZoneView()));

export function whenHasSystemRole(role: SystemRoleBit): ApplicationStatePredicate {
  return (snapshot) => getBuilderState(snapshot).hasSystemRole(role);
}
